export interface Interval {
  open: string;
  close: string;
}

/** "09:00–13:00, 14:00–18:30", or the given text when closed. */
export const formatIntervals = (intervals: readonly Interval[], closedText: string): string =>
  intervals.length === 0
    ? closedText
    : intervals.map(({ open, close }) => `${open}–${close}`).join(", ");

/** Drop half-filled rows before saving; keep the rest as typed. */
export const completeIntervals = (intervals: readonly Interval[]): Interval[] =>
  intervals.filter(({ open, close }) => open && close).map(({ open, close }) => ({ open, close }));

/** A name for a 0 (Monday) … 6 (Sunday) weekday in the given locale. */
export const weekdayName = (weekday: number, locale: string): string => {
  // 2024-01-01 was a Monday
  const reference = new Date(Date.UTC(2024, 0, 1 + weekday, 12));

  return new Intl.DateTimeFormat(locale, { weekday: "long", timeZone: "UTC" }).format(reference);
};
